module.exports = __webpack_public_path__ + "media/images/error-5723a1fa.svg";